export default {
  metadata: {
    version: '1.0.0',
    id: 'tab-item-1.0.0',
    name: 'JDSTabItem'
  },
  hierarchy: {
    'outer-container': [
      {
        container: ['icon', 'text']
      }
    ]
  },
  base: {
    'outer-container': {
      'background-color': '{t_0}',
      'flex-direction': '{t_1}',
      'align-items': '{t_2}',
      'justify-content': '{t_3}',
      'min-height': '{t_4}',
      height: '{t_6}',
      width: '{t_5}',
      opacity: '{t_33}',
      behavior: {
        hover: {},
        active: {}
      }
    },
    container: {
      'flex-direction': '{t_7}',
      'align-items': '{t_8}',
      'justify-content': '{t_9}',
      gap: '{t_10}',
      flex: 1,
      'padding-top': '{t_11}',
      'padding-bottom': '{t_12}',
      'padding-right': '{t_13}',
      'padding-left': '{t_14}',
      behavior: {
        focus: {
          'border-width': '{t_15}',
          'border-color': '{t_16}',
          'border-radius': '{t_17}'
        }
      }
    },
    text: {
      color: '{t_22}',
      'font-family': '{t_24}',
      'font-size': '{t_23}',
      'line-height': '{t_26}',
      'letter-spacing': '{t_27}',
      'font-weight': '{t_25}',
      'max-lines': 2,
      behavior: {
        hover: {
          color: '{t_28}'
        },
        active: {
          color: '{tabitem_base_text_behavior_active_color}'
        }
      }
    },
    icon: {
      size: '{t_18}',
      color: '{t_19}',
      hidden: false,
      behavior: {
        hover: {
          color: '{t_20}'
        },
        active: {
          color: '{t_21}'
        }
      }
    }
  },
  variant: {
    kind: {
      label: {
        icon: {
          hidden: true
        }
      },
      icon: {
        text: {
          hidden: true
        }
      }
    },
    disabled: {
      true: {
        'outer-container': {
          disabled: true,
          opacity: '{t_34}'
        },
        container: {
          disabled: true
        }
      }
    },
    appearance: {
      normal: {
        text: {
          behavior: {
            hover: {
              color: '{t_35}'
            },
            active: {
              color: '{t_36}'
            }
          }
        }
      },
      tab_bar: {
        container: {
          mode: 'dark',
          behavior: {
            active: {
              'background-color': '{t_37}'
            },
            focus: {
              'border-color': '{t_38}'
            }
          }
        },
        text: {
          color: '{t_42}',
          behavior: {
            hover: {
              color: '{t_43}'
            },
            active: {
              color: '{t_44}'
            }
          }
        },
        icon: {
          color: '{t_39}',
          behavior: {
            hover: {
              color: '{t_40}'
            },
            active: {
              color: '{t_41}'
            }
          }
        }
      }
    }
  },
  combination: [
    {
      active: {
        normal: {
          text: {
            color: '{t_46}'
          },
          icon: {
            color: '{t_45}'
          }
        }
      }
    }
  ],
  combination_config: [['state', 'appearance']],
  api: {
    config: {
      state: {
        values: ['inactive', 'active']
      },
      kind: {
        values: ['label_icon', 'label', 'icon']
      },
      appearance: {
        values: ['normal', 'tab_bar']
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      text: {
        value: {
          type: 'string',
          name: 'label'
        }
      },
      icon: {
        value: {
          type: 'icon',
          name: 'icon'
        }
      }
    },
    events: {
      'outer-container': {
        onAppear: {
          name: 'onAppear',
          platform: 'ios, android'
        }
      },
      container: {
        onClick: 'onClick'
      }
    },
    a11y: {
      'outer-container': {
        properties: {
          role: {
            value: 'tab'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-selected': '_ariaSelected'
        }
      }
    }
  }
};
